import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_CouplingRouter1838eiczuwvo5 as get_CouplingRouter } from './CouplingRouter.mjs';
import {
  setDefaultKey3cxjznx5hbyql as setDefaultKey,
  addChildspxcpid5g99g as addChild,
} from '../../../../../../kotlin-react-core/react/ChildrenBuilder.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function CouplingRouter(_this__u8e3s4, animationsDisabled, thirdPartyAvatarsDisabled, config, key) {
  key = key === VOID ? null : key;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var component = get_CouplingRouter();
  setDefaultKey(_this__u8e3s4, '@rdk/16_4');
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = ($this$component) => {
    $this$component.animationsDisabled = animationsDisabled;
    $this$component.thirdPartyAvatarsDisabled = thirdPartyAvatarsDisabled;
    $this$component.config = config;
    var tmp0_safe_receiver = key;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$component.key = tmp0_safe_receiver;
    }
    return Unit_instance;
  };
  addChild(_this__u8e3s4, component, block);
}
//region block: exports
export {
  CouplingRouter as CouplingRoutervjy16jvkym0p,
};
//endregion

//# sourceMappingURL=CouplingRouterKt.mjs.map
